import React, {FC} from 'react';

import {AbsoluteDateTimeFormatterContainer} from './absoluteDateTimeFormatterContainer';
import {RelativeDateTimeFormatsEnum, RelativeDateTimeFormatter} from './relativeDateTimeFormatter';

/*
 * Props.
 */

export enum DateTimeFormatsEnum {
  RELATIVE,
  ABSOLUTE,
}

export interface DateTimeFormatterProps {
  /** The date to format. */
  value: number;
  /** Whether we should display a relative or absolute date. */
  format?: DateTimeFormatsEnum;
  /** The format to use for relative dates. */
  relativeFormat?: RelativeDateTimeFormatsEnum;
}

/*
 * Component.
 */

export const DateTimeFormatter: FC<DateTimeFormatterProps> = (props) => {
  if (props.format === DateTimeFormatsEnum.ABSOLUTE) {
    return <AbsoluteDateTimeFormatterContainer value={props.value} />;
  }

  return <RelativeDateTimeFormatter value={props.value} format={props.relativeFormat} />;
};
